import { Form } from 'antd';
import { useSectors } from '@/hooks/v1';
import { useResolution886Report } from '@/context/Resolution886Report';

interface SectorProps {
	fieldName?: string | string[];
}

const { useFormInstance, useWatch } = Form;

export function useSector({ fieldName }: SectorProps) {
	const { newReview, firstReview } = useResolution886Report();
	const form = useFormInstance();
	const field = Array.isArray(fieldName) ? fieldName[0] : null;

	const organizationId = useWatch(field ? [field, 'organization_id'] : 'organization_id');
	const companyId = useWatch(field ? [field, 'company_id'] : 'company_id');
	const sectorId = useWatch(field ? [field, 'sector_id'] : 'sector_id');

	function handleSectorSelect(id: string): void {
		form.setFieldValue(field ? [field, 'sector_id'] : ['sector_id'], id);
		form.setFieldValue(field ? [field, 'line_id'] : ['line_id'], undefined);
		form.setFieldValue(field ? [field, 'workstation_id'] : ['workstation_id'], undefined);
	}

	function handleClearSector(): void {
		form.setFieldValue(field ? [field, 'sector_id'] : ['sector_id'], undefined);
		form.setFieldValue(field ? [field, 'line_id'] : ['line_id'], undefined);
		form.setFieldValue(field ? [field, 'workstation_id'] : ['workstation_id'], undefined);
	}

	const {
		isLoading,
		isFetching,
		data: sectors = [],
		isError
	} = useSectors({
		organizationId,
		companyId
	});

	const items = sectors.map((sector) => ({
		label: sector.name,
		value: sector.id
	}));

	const isDisabled = !companyId || isLoading || isFetching || newReview || !firstReview;

	return {
		isLoading,
		isFetching,
		items,
		isError,
		sectorId,
		isDisabled,
		handleSectorSelect,
		handleClearSector
	};
}
